export class PriceRuleLocationCountryView {
    public countryCode: string;
    public countryName: string;
}